import React from 'react';
import { Img, Neon, BgImage } from '../../components';
import { Content, Description, FeaturedImg, Wrapper } from './Bio.styled';

export default function Bio({ data }) {
	const { title, description } = data.site.siteMetadata;

	return (
		<Wrapper>
			{/* Background Image */}
			{data?.bgImage?.childImageSharp?.gatsbyImageData && (
				<BgImage
					src={data.bgImage.childImageSharp.gatsbyImageData}
					alt="Background"
				/>
			)}

			<Neon as="h1" color="green">
				About
			</Neon>

			<Content className="card">
				<Description>{description}</Description>

				{/* Action Shot Image */}
				{data?.actionImage?.childImageSharp?.gatsbyImageData && (
					<FeaturedImg>
						<Img
							src={
								data.actionImage.childImageSharp.gatsbyImageData
							}
							alt={title}
						/>
						<div className="overlay"></div>
					</FeaturedImg>
				)}
			</Content>
		</Wrapper>
	);
}
